module.exports = __webpack_public_path__ + "img/welcome-desktop-2.ddd157c2.png";